import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "Faqs"
}
const _hoisted_2 = { class: "FaqContent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FaqItem = _resolveComponent("FaqItem")!

  return (!_ctx.isFaqsEmpty)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "FaqHeader" }, [
          _createElementVNode("h2", { class: "FaqTitle" }, "Students frequently ask")
        ], -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (faq) => {
            return (_openBlock(), _createElementBlock("li", null, [
              _createVNode(_component_FaqItem, {
                question: faq.question,
                answer: faq.answer
              }, null, 8 /* PROPS */, ["question", "answer"])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ]))
    : _createCommentVNode("v-if", true)
}